import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { ShowTableSuratSomasiTahap2 } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { ButtonModifier, Loader, SearchBar, ScrollToTop } from "../../../components";
import { Box, Button, Divider, Pagination, Typography } from "@mui/material";
import { Col, Row, Form } from "react-bootstrap";

const TampilSuratSomasiTahap2 = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.pathname.split("/")[2];
  const [data, setData] = useState([]);
  const [detail, setDetail] = useState(null);
  const [query, setQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isFetchError, setIsFetchError] = useState(false);
  const textRight = { textAlign: screenSize >= 650 ? "right" : undefined };
  const authBody = { id: user._id, token: user.token, kodeCabang: user.cabang ? user.cabang._id : undefined };

  const handleError = (error) => {
    if (error.response && error.response.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
      return;
    }
    setIsFetchError(true);
  };

  const getRows = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        tempUrl + "/suratSomasiTahap2sPagination?search_query=" + encodeURIComponent(searchTerm) + "&page=" + page + "&limit=20",
        authBody
      );
      setData(response.data.suratSomasiTahap2s || []);
      setPage(response.data.page || 0);
      setPages(response.data.totalPage || 0);
      setRows(response.data.totalRows || 0);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getById = async () => {
    setLoading(true);
    try {
      const response = await axios.post(tempUrl + "/suratSomasiTahap2s/" + id, authBody);
      setDetail(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteData = async () => {
    if (!detail) return;
    setLoading(true);
    try {
      await axios.post(tempUrl + "/deleteSuratSomasiTahap2/" + detail._id, authBody);
      navigate("/suratSomasiTahap2");
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) getById();
  }, [id]);

  useEffect(() => {
    if (!id) getRows();
  }, [page, searchTerm]);

  const searchData = (event) => {
    event.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  if (loading) return <Loader />;
  if (isFetchError) return <FetchErrorHandling />;

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>Surat Somasi Tahap 2</Typography>
      <Divider sx={dividerStyle} />
      {detail ? (
        <>
          <Box sx={buttonModifierContainer}>
            <ButtonModifier id={detail._id} kode={detail.noJual} addLink="/suratSomasiTahap2/tambahSuratSomasiTahap2" editLink={"/suratSomasiTahap2/" + detail._id + "/edit"} deleteUser={deleteData} nameUser={detail.noJual} />
          </Box>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>No. Surat :</Form.Label>
                <Col sm="8"><Form.Control value={detail.noSuratSomasiTahap2 || ""} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Tanggal :</Form.Label>
                <Col sm="8"><Form.Control value={formatDate(detail.tglSuratSomasiTahap2)} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>No. Jual :</Form.Label>
                <Col sm="8"><Form.Control value={detail.noJual || ""} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Nama Register :</Form.Label>
                <Col sm="8"><Form.Control value={detail.namaRegister || ""} disabled /></Col>
              </Form.Group></Col></Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Tahap Somasi :</Form.Label>
                <Col sm="8"><Form.Control value={detail.suratSomasiKe || ""} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Telepon :</Form.Label>
                <Col sm="8"><Form.Control value={detail.tlpRegister || ""} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Eksekutor :</Form.Label>
                <Col sm="8"><Form.Control value={detail.kodeKolektor || ""} disabled /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>No. Polisi :</Form.Label>
                <Col sm="8"><Form.Control value={detail.nopol || ""} disabled /></Col>
              </Form.Group></Col></Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      ) : (
        <>
          <Box sx={buttonModifierContainer}>
            <ButtonModifier id={null} kode={null} addLink="/suratSomasiTahap2/tambahSuratSomasiTahap2" editLink={null} deleteUser={null} nameUser="" />
          </Box>
          <Form onSubmit={searchData}>
            <Box sx={searchBarContainer}>
              <SearchBar value={query} setSearchTerm={setQuery} />
              <Button variant="contained" type="submit" disableElevation>Cari</Button>
            </Box>
          </Form>
          <Typography sx={totalStyle}>Total data: {rows.toLocaleString("en-US")}</Typography>
          <Box sx={tableContainer}><ShowTableSuratSomasiTahap2 currentPosts={data} /></Box>
          <Box sx={tableContainer}><Pagination count={pages} page={page + 1} onChange={(event, value) => setPage(value - 1)} color="primary" size={screenSize <= 600 ? "small" : "large"} /></Box>
        </>
      )}
    </Box>
  );
};

export default TampilSuratSomasiTahap2;

const subTitleText = { fontWeight: "900" };
const buttonModifierContainer = { mt: 4, display: "flex", flexWrap: "wrap", justifyContent: "center" };
const dividerStyle = { pt: 4 };
const showDataContainer = { mt: 4, display: "flex", flexDirection: { xs: "column", sm: "row" } };
const showDataWrapper = { display: "flex", flex: 1, flexDirection: "column", maxWidth: { md: "40vw" } };
const secondWrapper = { marginLeft: { sm: 4 }, marginTop: { sm: 0, xs: 4 } };
const searchBarContainer = { pt: 6, display: "flex", justifyContent: "center" };
const tableContainer = { pt: 4, display: "flex", justifyContent: "center" };
const totalStyle = { mt: 3, fontWeight: "bold" };
